import DraggableTable from './draggable';
import TableColumn from './column';

export default class Table extends DraggableTable {

}

export {Table, TableColumn};
